/**
 * @format
 * @flow
 */
import LeaderPicture from './LeaderPicture';
import { Score } from './Ranking';
import { useTranslation } from 'react-i18next';

type Props = {
  leaders: Array<Score>,
};

const LeaderBoard = ({ leaders }: Props) => {
  const { t } = useTranslation();
  const renderLeader = (leader: Score, position: number, text: string) => {
    return (
      <div
        style={
          position === 1
            ? { marginLeft: 10, marginRight: 10, alignItems: 'center' }
            : { marginLeft: 10, marginRight: 10, marginTop: 75, alignItems: 'center' }
        }
      >
        <div
          style={{
            textAlign: 'center',
            fontFamily: 'Earth orbiter',
            marginBottom: 10,
            fontSize: '20px',
          }}
        >
          <span style={{ fontSize: '35px' }}>{position}</span>
          {text}
        </div>
        <LeaderPicture
          photoStorageLink={leader.photoStorageLink}
          size={position === 1 ? 150 : 125}
          isFirst={position === 1}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <p
            style={{
              marginTop: 20,
              width: position === 1 ? 150 : 125,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              fontFamily: 'Nasalization',
              fontSize: 15,
            }}
          >
            {leader.userName === 'atlantideAgent' ? t('screens.dashboard.anonymous') : leader.userName}
          </p>
        </div>
      </div>
    );
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
      {leaders.length >= 2 && renderLeader(leaders[1], 2, 'nd')}
      {leaders.length >= 1 && renderLeader(leaders[0], 1, 'st')}
      {leaders.length >= 3 && renderLeader(leaders[2], 3, 'rd')}
    </div>
  );
};

export default LeaderBoard;
